{
  "label": "Questions de discussion",
  "close": "Fermer",
  "empty": "Il n'y a aucune question de discussion pour ce message."
}
